import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ServiceContext } from "../../context"
import { catalog } from "../../../../../../utils/constants/callService"
import { returnQuery, returnQueryWithPagination } from "../../../../../../utils/methods/returnQuery"
import { useContextState } from "../../../../../../hooks/theme"
import { Status, Types } from "../../../../../../utils/enums"
import { formatTableResponse } from "./methods/formatEndpointResponseToInformation"
import { ClickPayload, Settings } from "../../../../../../components/settings"
import { ItemMenu } from "../../../../../../components/baseMenu"
import { formatFilter, formatSort } from "./constans/constants"
import { useDownload } from "../../../../../../hooks/download/useDownload"

const useBody = () => {
  const styles = useStyles()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { colors } = useContextState()
  const [settingData, setSettingData] = useState<ClickPayload>()
  const [totalPages, setTotalPages] = useState(0)
  const refTime = useRef<NodeJS.Timeout | null>(null)

  const { CatalogData, filterCatalog } = useContext(ServiceContext)
  const { input, getData } = CatalogData
  const { counter, errors, filterData, paginationModel, query, filterString, sortTable, handlePagination, onChange, cleanFilter } = filterCatalog
  const [loading, setLoading] = useState({
    table: false,
  })

  useEffect(() => {
    getData()
  }, [])

  const [table, setTable] = useState<{ row: any[]; rowCopy: any[] }>({
    row: [],
    rowCopy: [],
  })

  const [idStatus,setIdStatus] = useState<number | undefined>()
  const status = useMemo(() => {
    const user = table.row.find((item) => item.id === idStatus);
    return user ? user.statusId : undefined; 
  }, [idStatus, table.row]);

  const [modalDelete, setModalDelete] = useState<{
    open: boolean;
    title?: string;
    description?: string;
    cancel?: () => void;
    confirm?: () => void;
  } | null>({
    open: false
  });

  const [openSnackbar, setOpenSnackbar] = useState({
    open: false,
    type: Types.SUCCESS,
    message: ''
  })

  const menu: ItemMenu[] = [
    { label: status== Status.ACTIVE ? t('general.tags.desactivate'):t('general.tags.activate'), value: 1 },
    { label: t('general.edit'), value: 2 },
    { label: t('general.delete'), value: 3 },
  ];

  const closeModalDelete = () => {
    setModalDelete((prevState) => ({
      ...prevState,
      open: false,
    }));
  };
  const closeSnackbar = () => { setOpenSnackbar(prev => ({ ...prev, open: false })) }

  const openModalDelete = async ({ id }: { id: string }) => {
    setModalDelete((prevState) => ({
      ...prevState,
      open: true,
      title: t('catalog.form.deleteCatalog'),
      description: t('catalog.form.deleteCatalogDescription'),
      confirm: () => { deleteItem({ id }) }
    }));
  };

  const getCatalogs = async () => {
    setLoading(prev => ({
      ...prev,
      table: true
    }))

    const response = await catalog.getTableCatalogs({ query: returnQuery({ ...filterCatalog.query, filter: filterCatalog.query.filter?.replaceAll('+', '%2B') }, formatSort) },)

    const { row, totalPages } = formatTableResponse({ response, t, colors })

    setTable(prev => ({
      ...prev,
      row,
    }))
    setTotalPages(totalPages)
    setLoading(prev => ({
      ...prev,
      table: false
    }))
  }

  useEffect(() => {
    if (refTime.current) { clearTimeout(refTime.current) }

    refTime.current = setTimeout(() => {
      getCatalogs()
    }, 300)
  }, [filterCatalog.query.all])

  const deleteItem = async ({ id }: { id: string }) => {
    const response = await catalog.deleteCatalog(id)

    if (!response?.errors) {
      closeModalDelete()
      setOpenSnackbar(prev => ({
        ...prev,
        open: true,
        type: Types.SUCCESS,
        message: t(`catalog.modal.delete.success.title`)
      }))
      getCatalogs()
    } else {
      setOpenSnackbar(prev => ({
        ...prev,
        open: true,
        type: Types.ERROR,
        message: t(`catalog.modal.delete.error.title`)
      }))
    }
  }

  const editStatus = async ({ id }: { id: string }) => {
    const response = await catalog.editStatus(id)
    setIdStatus(undefined)
    if (!response?.errors) {
      closeModalDelete()
      setOpenSnackbar(prev => ({
        ...prev,
        open: true,
        type: Types.SUCCESS,
        message: t(`catalog.modal.statusUpdate.success.title`)
      }))
      getCatalogs()
    } else {
      setOpenSnackbar(prev => ({
        ...prev,
        open: true,
        type: Types.ERROR,
        message: t(`catalog.modal.statusUpdate.error.title`)
      }))
    }
  }

  const click = (payload: ClickPayload) => {
    setIdStatus(Number(payload.id))
    setSettingData(payload)
  }

  const closeMenu = () => {
    setSettingData(undefined)
  }

  const optionMenu = ({ item }: { item: ItemMenu }) => {

    if (item.value == 1) {
      if (settingData?.id) {
        editStatus({id: settingData?.id})
      }
      return;
    }

    if (item.value == 2) {
      navigate(`edit/${settingData?.id}`)
      return;
    }

    if (item.value == 3) {
      if (settingData?.id) {
        openModalDelete({ id: settingData?.id })
      }
      return;
    }

  }

  const queryv2 = returnQueryWithPagination({filter: filterCatalog.filterString,sort: filterCatalog.query?.sort,}, formatFilter).replace('&','')

    const downloadMain = useDownload({
      docName: t('catalog.title'),
      query: queryv2,
      downloadFuntion: catalog.downloadFile,
    })


  const columnMain = [
    {
      id: 'name',
      label: t('catalog.tags.name'),
      headerCell: styles?.headerTable,
      sortable: true
    },
    {
      id: 'categoriesCount',
      label: t('catalog.tags.associatedCategories'),
      headerCell: styles?.headerTable,
      sortable: true
    },
    {
      id: 'status',
      label: t('catalog.tags.state'),
      headerCell: styles?.headerTable,
    },
    {
      id: 'actions',
      label: t('catalog.tags.actions'),
      headerCell: styles?.headerTableActions,
      renderCell: ({ row }: any) => {
        return (
          <Settings
            row={row}
            click={click}
            rowLength={table?.row?.length}
            disable={row.execution == 0}
          />
        );
      },
    },
  ]


  return {
    columnMain,
    table,
    cleanFilter,
    counter,
    errors,
    input,
    filterData,
    onChange,
    modalDelete,
    closeModalDelete,
    loading,
    openSnackbar,
    closeSnackbar,
    closeMenu,
    optionMenu,
    menu,
    settingData,
    paginationModel,
    totalPages,
    handlePagination,
    filterCatalog,
    downloadMain
    /* query */
  }
}


export { useBody }